import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-13dbb395"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ShowXRatedConfirmation__overlay"
  }, null, -1);
});
var _hoisted_2 = {
  "class": "ShowXRatedConfirmation__container--transparent"
};
var _hoisted_3 = {
  key: 0,
  "class": "ShowXRatedConfirmation__container"
};
var _hoisted_4 = {
  "class": "ShowXRatedConfirmation__text"
};
var _hoisted_5 = {
  key: 1,
  "class": "ShowXRatedConfirmation__container"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ShowXRatedConfirmation__text"
  }, [/*#__PURE__*/_createTextVNode(" Would you like to view the "), /*#__PURE__*/_createElementVNode("div", null, "X-rated version of this gallery"), /*#__PURE__*/_createElementVNode("div", null, "and become a PRO member?")], -1);
});
var _hoisted_7 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "width": "100%",
    "padding": "10px",
    "gap": "15px",
    "height": "70px"
  }
};
var _hoisted_8 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_9 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ShowXRatedConfirmation__lower"
  }, "Becoming pro allows you more daily conversations, free monthly token drops, access to better features, chat history and more!", -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "ShowXRatedConfirmation__lower ShowXRatedConfirmation__lower--bold"
  }, "Cancel at anytime", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [false ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createTextVNode(" X-Rated Conversations Supported Today but Images Coming Soon! "), _createElementVNode("button", {
    "class": "button button--selected",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$store.commit('updateIntroShowXRatedConfirmation', false);
    })
  }, "Close Window")])])) : _createCommentVNode("", true), true ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$store.commit('updateIntroShowXRatedConfirmation', false);
    }),
    "class": "button button--secondary",
    style: {
      "padding-top": "0px"
    }
  }, "Nevermind")]), _createElementVNode("div", _hoisted_9, [_createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.showPayScreen();
    }),
    "class": _normalizeClass({
      button: true,
      'button--disabled': false
    }),
    style: {
      "padding-top": "0px"
    }
  }, "See Details")])]), _hoisted_10, _hoisted_11])) : _createCommentVNode("", true)])]);
}